export function setAttributes<K extends HTMLElement | SVGSVGElement>(
  element: K,
  attributes: Record<
    string,
    string | number | Array<string> | Array<number> | object | boolean
  >,
): K {
  for (const attribute in attributes) {
    const value = attributes[attribute];
    if (value !== undefined && value !== null) {
      element.setAttribute(
        attribute,
        Array.isArray(value)
          ? value.join(' ')
          : typeof value === 'object'
            ? JSON.stringify(value)
            : String(value),
      );
    } else {
      element.removeAttribute(attribute);
    }
  }

  return element;
}
